// @ts-nocheck
import { useSetCategoryHiddenMutation } from 'api/graphql/types.generated'
import { useGraphQLClient } from 'providers/hooks'

export function useSetCategoryHidden() {
  const { graphQLClient } = useGraphQLClient()

  const queryInfo = useSetCategoryHiddenMutation(
    graphQLClient,
    {
      suspense: false,
      useErrorBoundary: true
    },
    {
      'Content-Type': 'application/json'
    }
  )

  return {
    data: queryInfo.data?.setCategoryHidden,
    isLoading: queryInfo.isLoading,
    mutate: queryInfo.mutateAsync
  }
}
